/* Bread Code — which button created the cart?
 *
 * Shopify counts carts and checkouts but not the button behind them. This
 * file does two small things on every buy button:
 *   1. sends an anonymous beacon (event, source, page) to breadco.de, and
 *   2. stamps the cart attribute `bc_source`, so Shopify's own abandoned
 *      checkouts and orders carry the source too.
 * No cookie, no visitor id, no personal data leaves the page.
 *
 * Sources: main (product form button), sticky (mobile sticky bar),
 * bundle_nudge (block under the buy box), bundle_section (bundle offer).
 */
(function () {
  var ENDPOINT = 'https://breadco.de/api/shop-events';
  var pendingSource = null;

  function beacon(event, source) {
    var body = JSON.stringify({ event: event, source: source || null, page: location.pathname });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, body)) return;
    } catch (e) { /* fall through */ }
    try {
      fetch(ENDPOINT, { method: 'POST', body: body, mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) { /* tracking must never break the shop */ }
  }

  function stamp(source) {
    return fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { bc_source: source } })
    }).catch(function () {});
  }

  // Public: the bundle handlers call this after their own /cart/add.js, so the
  // stamp never races the add on a brand-new cart.
  window.bcTrack = { beacon: beacon, stamp: stamp };

  // The sticky bar clicks the main button, so remember which one the user hit.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.bc-sticky-atc__btn')) { pendingSource = 'sticky'; return; }
    if (t.closest('.bc-bundle-nudge__btn')) { beacon('add_to_cart', 'bundle_nudge'); return; }
    if (t.closest('.bundle-offer__add')) { beacon('add_to_cart', 'bundle_section'); return; }
    var checkout = t.closest('button[name="checkout"]');
    if (checkout) beacon('checkout_click', checkout.getAttribute('data-bc-source') || null);
  }, true);

  // The product form posts /cart/add.js itself and, with the cart set to
  // "page", redirects to /cart as soon as the add succeeds. Stamping in
  // parallel with the add would race it on a brand-new cart (two carts, one
  // cookie), so the tap is counted here and the source is handed to the next
  // page through sessionStorage, where the cart already exists.
  var HANDOFF = 'bc_source';
  function remember(source) { try { sessionStorage.setItem(HANDOFF, source); } catch (e) { /* private mode */ } }
  function recall() { try { var v = sessionStorage.getItem(HANDOFF); sessionStorage.removeItem(HANDOFF); return v; } catch (e) { return null; } }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var source = pendingSource || 'main';
    pendingSource = null;
    beacon('add_to_cart', source);
    remember(source);
  }, true);

  // Drawer or notification cart: Dawn stays on the page and publishes the add.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;
      var source = recall();
      if (source) stamp(source);
    });
    if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function () { recall(); });
  }

  // Page cart: we arrive on /cart with the item already in the cart.
  if (location.pathname.indexOf('/cart') === 0) {
    var handed = recall();
    if (handed) {
      stamp(handed);
      var buttons = document.querySelectorAll('button[name="checkout"]');
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('data-bc-source', handed);
    }
  }
})();
